
import React from 'react';

interface SectionHeaderProps {
  title: string;
  description: string;
}

const SectionHeader = ({ title, description }: SectionHeaderProps) => {
  return (
    <div className="text-center mb-16">
      <h2 className="text-primary text-3xl md:text-4xl font-bold mt-2 mb-4">{title}</h2>
      <p className="text-paragraph max-w-2xl mx-auto">
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;
